module.exports = __webpack_public_path__ + "img/wait.cd216d52.svg";